import { render, staticRenderFns } from "./ShowRuche.vue?vue&type=template&id=ffe5769c&"
import script from "./ShowRuche.vue?vue&type=script&lang=js&"
export * from "./ShowRuche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports